<template>
  <div :class="{slide: true, 'menuFold': foldTab === 1, 'menuExpand': foldTab === 2}" v-click-outside="closeMenu">
    <div class="menu" >
      <div class="tabs" v-for="(tab, tabindex) in tabs" :key="tabindex" :ref="`tab${tabindex}`">
        <div :class="{tab: true}" @click="switchTab(tab, {}, tabindex)">
          <img class="icon" :src="(tab.expand || tab.children.filter(i => i.idstring === activeTabId).length > 0) ? tab.icon.on :tab.icon.normal" alt="icon" @mouseover="showFloatTitle(tab, true, tabindex)" @mouseout="showFloatTitle(tab, false, tabindex)">
          <span class="title" v-if="animCon">
            {{tab.name}}
          </span>
          <i class="tip" :style="{right: animCon ? '52px': '18px', top: foldTab !== 1 ? '50%' : '20px'}" v-if="tab.new_num - 0 === -1"></i>
          <img class="arrow" v-if="animCon && tab.children && tab.children.length > 0" :src="tab.expand ? icons.up : icons.down" alt="switch">
        </div>
        <div :data-i="child.idstring" :class="{tab: true, child: true, hoverTab: true, active: child.idstring == activeTabId}" v-show="foldTab !== 1 && tab.children && tab.expand" v-for="(child, childIndex) in tab.children" :key="childIndex" @click="switchTab(child, tab, tabindex)">
          <span class="title">
            {{child.name}}
          </span>
          <i v-if="child.new_num - 0 === -1" class="tip"></i>
        </div>
        <div class="floatMenu" :ref="`flt${tabindex}`" :style="{top: calcFloatTop(tabindex)}" v-show="(tab.idstring === activeTabId || tab.expand) && foldTab === 1">
          <!-- <div class="tabName">{{tab.name}}</div> -->
          <div :class="{tab: true, child: true, hoverTab: true, floatTab: true, active: child.idstring === activeTabId}" v-show="tab.children" v-for="(child, childIndex) in tab.children" :key="childIndex" @click="switchTab(child, tab, tabindex)">
            <span class="title">
              {{child.name}}
            </span>
            <i v-if="child.new_num - 0 === -1" class="tip floatTip"></i>
          </div>
        </div>
        <div v-show="tab.showFloatTitle && foldTab === 1 && !tab.expand" class="floatTitle" :ref="`flti${tabindex}`">
          <img src="@assets/img/common/floatAngle.svg" alt="angle">
          <span>
            {{tab.name}}
          </span>
        </div>
      </div>
    </div>
    <div class="bottom">
      <img @click="toggleMenu()" class="toggler" :src="foldTab === 1 ? icons.toggle : icons.toggleR" alt="toggler">
    </div>
  </div>
</template>
<script>
import common from '@common/common'
import {apis} from '@common/config'
import vClickOutside from "v-click-outside";

export default {
  name: 'slide',
  directives: {
    clickOutside: vClickOutside.directive
  },
  watch: {
    $route: {
      handler: function(val, from) {

        // 监听路由，首页时折叠所有选项
        const match = this.checkMatch(val.path)

        if (!match) {
          if (val.path === '/index') {
            this.activeTab = ''
            this.activeTabId = ''
            this.unexpandAll({})
          }
        }

        this.autoSwitch()

        // 跳转到统一内容库后侧边栏收起
        if(val.name === 'unifiedContentLibrary' || val.name === 'onlinePlayingLibrary') {
          this.foldTab = 1
          this.menuExpandReset()
          this.$emit('getToggle', this.foldTab === 1)
          this.isUnifiedContentLibrary = true
        }else if(from && from.name === 'unifiedContentLibrary') {
          this.foldTab = 0
          this.$emit('getToggle', this.foldTab === 1)
          let time = 0
          if (this.foldTab !== 1) {
            time = 300
          }
          setTimeout(() => {
            this.animCon = this.foldTab !== 1
          }, time)
          this.isUnifiedContentLibrary = false
        }else {
          this.isUnifiedContentLibrary = false
        }
        // 跳转到统一内容库后侧边栏收起
      },
      immediate: true
    }
  },
  data() {
    return {
      icons: {
        up: require('../assets/img/slide/up.svg'),
        down: require('../assets/img/slide/down.svg'),
        toggle: require('@assets/img/common/menu-toggler.svg'),
        toggleR: require('@assets/img/common/menu-toggler-r.svg')
      },
      tabs: [],
      menuTabs: [ // 所有一级菜单的idstring及icon
        {
          idstring: 'xuanti',
          icon: {
            normal: require('../assets/img/slide/xuanti.svg'),
            on: require('../assets/img/slide/xuanti_on.svg')
          }
        },
        {
          idstring: 'caifang',
          icon: {
            normal: require('../assets/img/slide/caifang.svg'),
            on: require('../assets/img/slide/caifang_on.svg')
          }
        },
        {
          idstring: 'xiansuoku',
          icon: {
            normal: require('../assets/img/slide/material.svg'),
            on: require('../assets/img/slide/material_on.svg')
          }
        },
        {
          idstring: 'baodaobianji',
          icon: {
            normal: require('../assets/img/slide/baodao.svg'),
            on: require('../assets/img/slide/baodao_on.svg')
          }
        },
        {
          idstring: 'ziyuanguanli',
          icon: {
            normal: require('../assets/img/slide/ziyuan.svg'),
            on: require('../assets/img/slide/ziyuan_on.svg')
          }
        },
        {
          idstring: 'kaopingdafen',
          icon: {
            normal: require('../assets/img/slide/kaoping.svg'),
            on: require('../assets/img/slide/kaoping_on.svg')
          }
        },
        {
          idstring: 'shujuzhonxin',
          icon: {
            normal: require('../assets/img/slide/shuju.svg'),
            on: require('../assets/img/slide/shuju_on.svg')
          }
        },
        {
          idstring: 'bangongtian',
          icon: {
            normal: require('../assets/img/slide/bangong.svg'),
            on: require('../assets/img/slide/bangong_on.svg')
          }
        },
        {
          idstring: 'fabu',
          icon: {
            normal: require('../assets/img/slide/fabu.svg'),
            on: require('../assets/img/slide/fabu_on.svg')
          }
        },
        {
          idstring: 'xinmeitifabu',
          icon: {
            normal: require('../assets/img/slide/newfabu.svg'),
            on: require('../assets/img/slide/newfabu_on.svg')
          }
        },
        {
          idstring: 'tongyineirongku',
          icon: {
            normal: require('../assets/img/slide/material.svg'),
            on: require('../assets/img/slide/material_on.svg')
          }
        },
        {
          idstring: 'onlineplay',
          icon: {
            normal: require('../assets/img/slide/online.png'),
            on: require('../assets/img/slide/onlineOn.png')
          }
        },
      ],
      activeTab: '',
      activeTabId: '',
      foldTab: 0, //菜单状态 0: 初始状态 1: 收起状态 2: 展开状态
      animCon: true, // 菜单内文字和红点显示状态
      tabsUndo: [ // 这些菜单不执行“点击消除小红点”
        'examineReport', 'checkInterviews', 'publishAudit', 'resources'
      ],
      isUnifiedContentLibrary: false // 是否访问的是统一内容库
    }
  },
  methods: {
    closeMenu(){
      this.tabs.forEach(item=>{
        if(item.expand) {
          this.$set(item, 'expand', false)
        }
      })
    },
    showFloatTitle(t, f, i) {
      // 切换悬浮标题的显示
      this.$set(t, "showFloatTitle", f)
      this.$nextTick(() => {
        this.calcFloatTitleTop(i)
      })
    },
    asyncRootDot(father) {
      // 操作子节点小红点时同步父节点的状态
      this.$nextTick(() => {
        const childrenDots = father.children.filter(i => i.new_num - 0 === -1)
        if (childrenDots.length === 0) {
          this.$set(father, 'new_num', 0)
        } else {
          this.$set(father, 'new_num', -1)
        }
      })
    },
    checkMatch(path) {
      // 查看是否有匹配路径
      let match = false
      this.tabs.forEach((i) => {
        if (i.path === path) {
          match = true
        }
        if (i.children) {
          i.children.forEach((c) => {
            if (c.path === path) {
              match = true
            }
          })
        }
      })

      return match
    },
    unexpandAll(t) {
      // 折叠所有项
      this.tabs.forEach((i) => {
        if (t.name !== i.name) {
          this.$set(i, 'expand', false)
        }
      })
    },
    switchTab(item, father, i) {
      console.log('switchTab', item, father, i)

      // 统一内容库跳转
      if(item.idstring === 'tongyineirongku') {
        const path = this.$route.path
        if(path === '/unifiedContentLibrary') {
          window.location.reload()
        }
        
        // this.$router.push({
        //   path: '/unifiedContentLibrary'
        // })
        window.location.href = '/unifiedContentLibrary'

        // if(path === '/onlinePlayingLibrary'){
        //   // window.location.reload()
        //   console.log(77777)
        // }
        return
      }
      // 统一内容库跳转


      // 展开项目／切换路由
      if (!father.children) {
        // 点击项为父项
        this.unexpandAll(item)  // 关闭其他父项
        if (item.expand) {
          // 如果当前项已展开，则关闭
          this.$set(item, 'expand', false)
        } else {
          // 如果当前项关闭，则根据当前页面所在父项处理
          let childExpanded = item.children.filter(i => {
            return i.name === this.activeTab
          })

          if (childExpanded.length === 0) {
            // 如果当前页面不属于当前父项，展开当前父项，并定位到第一个子项页面；否则只展开当前父项，子项页面不切换
            // this.$router.push({
            //   path: item.children[0].path
            // })
            // this.activeTab = item.children[0].name
          }

          this.calcFloatTop(i)

          this.$set(item, 'expand', true)
        }
      } else {
        // console.log(item)
        // 点击项为子项，直接跳转页面
        const path = this.$route.path
        const target = `/${item.menu_type}/${item.idstring}`

        if(item.idstring === 'onlineplaylist') {
          const path = this.$route.path
          if(path === '/onlinePlayingLibrary') {
            window.location.reload()
          }
          // this.$router.push({
          //   path: '/onlinePlayingLibrary'
          // })
          window.location.href = '/onlinePlayingLibrary'

          this.menuExpandReset()

          // if(path === '/unifiedContentLibrary'){
          //   // window.location.reload()
          //   console.log(88888)
          // }
          return
        }

        if (path === target) {
          window.location.reload()
        }

        if (this.tabsUndo.indexOf(item.menu_type) === -1) {
          this.$set(item, 'new_num', 0)
          this.asyncRootDot(father)
        }

        this.$router.push({
          path: target
        })
        
        this.activeTab = item.name
        this.activeTabId = item.idstring
        // console.log(this.activeTab,this.activeTabId)
      }
    },
    autoSwitch() {
      // 加载时根据路径自动展开对应项
      const path = this.$route.path.split('/')[1]
      const id = this.$route.params.id
      // console.log(path)
      this.tabs.forEach((i) => {
        if (i.menu_type === path) {
          if(i.name == '策划'){
            this.activeTab = '策划库'
          }else{
            this.activeTab = i.name
          } 
          if(i.idstring == 'xuanti'){
            this.activeTabId = 'xuantiku'
            this.$set(i, 'expand', true)
          }else{
            this.activeTabId = i.idstring
          }
        } else {
          i.children && i.children.forEach((c) => {
            if (c.menu_type ===  path && id === c.idstring) {
              this.activeTab = c.name
              this.activeTabId = c.idstring
              if (this.tabsUndo.indexOf(path) === -1) {
                this.$set(c, 'new_num', 0)
                this.asyncRootDot(i)
              }
              this.unexpandAll({})
              if (this.foldTab === 1) {
                // 菜单折叠状态下，浮动菜单自动隐藏
              } else {
                this.$set(i, 'expand', true)
              }
            }
          })
        }
      })

      console.log(this.activeTabId)
    },
    sendRoutes(r) {
      // 传递路由数据
      this.$emit('passRoutes', r)
    },
    matchTabs(r) {
      // 根据数据配置权限
      r.forEach(i => {
        this.menuTabs.forEach(j => {
          if (i.idstring === j.idstring) {
            
            // 统一内容库特殊处理
            if(i.idstring == 'tongyineirongku') {
              i.children = []
            }else {
              i.children = i.son
            }
            // 统一内容库特殊处理

            i.name = i.title
            // i.children = i.son
            i.icon = j.icon
            i.children.forEach(c => {
              c.name = c.title
            })
          }
        })
      })

      this.tabs = r
    },
    getMenu() {
      // 左侧边栏数据
      return common.myFetch(apis.Site_menu, {data: {}, hideLoading: true})
      .then(r => {
        if (r) {
          return r
        }
      })
    },
    async getTabs(auto = false) {
      const r = await this.getMenu()

      this.sendRoutes(r.menu_auth)

      this.matchTabs(r.menu_auth)
      if (auto) {
        this.autoSwitch()
      }
    },
    getMenuNofify(string) {
      const info = {
        idstring: string
      }
      const data = {
        data: info,
        hideLoading: true
      }

      common.myFetch(apis.Site_menu_notify, data)
      .then((r) => {
        if (r) {
          this.tabs.forEach(i => {
            i.children.forEach(c => {
              console.log('小红点刷新', c.idstring, string)
              if (c.idstring === string) {
                this.$set(c, 'new_num', -1)
                this.asyncRootDot(i)
              }
            })
          })
        }
      })
    },
    getNotifyMenu(r) {
      if (r) {
        const idstring = r.idstring

        if (idstring) {
          this.getMenuNofify(idstring)
        }
      }
    },
    addDot(idstring) {
      // 手动添加小红点
      this.tabs.forEach(t => {
        if (t.string === idstring) {
          this.$set(t, 'new_num', -1)
        }

        t.children.forEach(tc => {
          if (tc.string === idstring) {
            this.$set(tc, 'new_num', -1)
          }
        })
      })
    },
    menuExpandReset() {
      // 菜单折叠时将已经展开的菜单收起
      this.tabs.forEach(i => {
        this.$set(i, 'expand', false)
      })
    },
    toggleMenu() {
      // 统一内容库无法点击按钮展开
      if(this.isUnifiedContentLibrary) {
        return
      }
      // 切换菜单展开或关闭
      this.foldTab = this.foldTab === 0 ? 1 : this.foldTab == 1 ? 2 : 1
      let time = 0
      if (this.foldTab !== 1) {
        time = 300
      } else {
        this.menuExpandReset()
      }
      setTimeout(() => {
        this.animCon = this.foldTab !== 1
      }, time)

      this.$emit('getToggle', this.foldTab === 1)
    },
    calcFloatTop(n) {
      // 计算的时机可能有些问题，需要在展开时再计算，后续优化
      // console.log(n)
      // 计算外部菜单距离顶部高度
      this.$nextTick(() => {
        const siteTop = 70 // 网站顶部高度
        const ele = this.$refs[`flt${n}`][0] // 当前菜单dom元素
        const tabEle = this.$refs[`tab${n}`][0] // tab菜单dom元素
        let realTop = 0 // 实际菜单距离顶部top值
        const eleRct = ele.getBoundingClientRect() // 当前菜单元素的尺寸属性
        const tabRct = tabEle.getBoundingClientRect()
        const tabTop = tabRct.top
        const eleHeight = eleRct.height // 当前菜单元素高度

        realTop = tabTop - siteTop

        if (realTop + eleHeight + siteTop > window.innerHeight) {
          // 当当前菜单元素根据索引计算后会超出屏幕高度时，则将实际top修改为当前菜单元素刚好沉底的高度
          realTop = window.innerHeight - siteTop - eleHeight
        }

        ele.style.top = `${realTop}px` // vue渲染时不会执行top计算，则在此处手动赋值
        return `${realTop}px`
      })
    },
    calcFloatTitleTop(n) {
      // 计算的时机可能有些问题，需要在展开时再计算，后续优化

      // 计算外部菜单距离顶部高度
      this.$nextTick(() => {
        const siteTop = 70 // 网站顶部高度
        const ele = this.$refs[`flti${n}`][0] // 当前菜单dom元素
        const tabEle = this.$refs[`tab${n}`][0] // tab菜单dom元素
        const offset = 15 // title的偏移量
        let realTop = 0 // 实际菜单距离顶部top值
        const tabRct = tabEle.getBoundingClientRect()
        const tabTop = tabRct.top

        realTop = tabTop + offset - siteTop

        ele.style.top = `${realTop}px` // vue渲染时不会执行top计算，则在此处手动赋值
        return `${realTop}px`
      })
    }
  },
  created() {
    this.getTabs(true)
  },
  mounted() {
    common.handleSocket(this.getNotifyMenu, 'menureminder')
  }
}
</script>
<style lang="less" scoped>
  @dark: #050f0f;
  @yellow: #f1c229;
  @red: #ff555a;
  @keyframes folding {
    0%{
      width: 230px;
    }
    100%{
      width: 72px;
    }
  }
  @keyframes expanding {
    0%{
      width: 72px;
    }
    100%{
      width: 230px;
    }
  }
  .menuFold {
    animation: folding 0.3s ease-in 1 normal forwards;
  }

  .menuExpand {
    animation: expanding 0.3s ease-in 1 normal forwards;
  }
  .slide {
    width: 100%;
    height: 100%;
    background-color: @dark;
    box-shadow:6px 6px 20px 0 rgba(5,10,15,0.20);
    display: flex;
    flex-direction: column;
    .menu {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      &::-webkit-scrollbar {
          width: 0;
      }
      &::-webkit-scrollbar-thumb {
          background: @dark;
          border-radius: 2px;
      }
      &::scrollbar {
          width: none;
      }
    }
    .bottom {
      flex-shrink: 0;
      height: 120px;
      padding: 10px 0 0 26px;
      .toggler {
        cursor: pointer;
        display: block;
      }
    }
    .tabs {
      color: #fff;
      font-size: 16px;
      // position: relative;
      .tab {
        height: 60px;
        display: flex;
        padding: 0 16px 0 26px;
        align-items: center;
        position: relative;
        border-left: 4px solid transparent;
        cursor: pointer;
        overflow: hidden;
        .icon {
          position: absolute;
          top: 50%;
          margin-top: -10px;
          width: 19px;
          height: 19px;
        }
        .title {
          margin-left: 48px;
        }
        .msg {
          width: 32px;
          height: 22px;
          line-height: 22px;
          font-size: 14px;
          text-align: center;
          border-radius: 100px;
          background-color: @red;
          right: 36px;
          position: absolute;
        }
        .tip {
          right: 52px;
          width: 8px;
          height: 8px;
          border-radius: 100%;
          background-color: @red;
          position: absolute;
          top: 50%;
          margin-top: -4px;
        }
        .arrow {
          position: absolute;
          right: 18px;
          top: 50%;
          margin-top: -3px;
        }
      }
      .hoverTab {
        &:hover {
          background-color:rgba(255,255,255,0.10);
        }
      }
      .child {
        background-color: rgba(255,255,255,0.05);;
      }
      .active {
        background-color:rgba(255,255,255,0.10);
        border-left: 4px solid @red;
      }
      .tabName {
        height: 60px;
        line-height: 60px;
        padding: 0 0 0 20px;
        background-color: rgba(5,15,15,0.05);
      }
      .floatMenu {
        position: absolute;
        width: 158px;
        left: 72px;
        top: 0;
        background-color: rgba(5,15,15,0.8);
      }
      .floatTab {
        padding: 0 20px 0 0;
        // border-bottom: 1px solid rgba(151, 151, 151, 0.8);
        .title {
          margin-left: 42px;
        }
      }
      .floatTip {
        right: 20px !important;
      }
      .floatTitle {
        position: absolute;
        width: 104px;
        height: 30px;
        line-height: 30px;
        left: 80px;
        top: 0;
        font-size: 16px;
        border-radius: 4px;
        text-align: center;
        background-color: rgba(5,15,15,0.8);
        img {
          position: absolute;
          left: -4px;
          top: 10px;
        }
      }
    }
  }
</style>
